import { BCMSRecord, Workflow, useBCMSContext } from "@bcm-dev/bcms-vite";
import EnterActivationCodeView from "components/custom-ui/CustomModal/components/AddContactMethodModal/components/EnterActivationCodeView";
import WelcomeView from "components/custom-ui/CustomModal/components/AddContactMethodModal/components/WelcomeView";
import Classes, { ContactInfo } from "model";
// Steps of the workflow
var steps = [
    WelcomeView,
    EnterActivationCodeView
];

/**
 * @function ConfirmContactMethodsModalWorkflow
 * 
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the add contact method modal workflow.
 */
export default function ConfirmContactMethodsModalWorkflow(props) {
    // Get the inital state of the workflow
    const controller = useBCMSContext();
    const { workflowType, refresh } = props;

    BCMSRecord.globalControllerFor(Classes, controller);

    const value = getDefaultConfirm(workflowType, refresh);
    // Return the workflow component
    return <Workflow value={ value } steps={ steps } />
}
// Return the steps of the workflow
export const getWorkflowStepsConfirm = () => steps;

/**
 * @function getDefault
 * 
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefaultConfirm = (type, refresh) => {
    return {
        data: {
            unconfirmedContacts: ContactInfo.initAll().filter(info => info.isConfirmed === "false", [])
        },
        ui: {
            workflowType: type,
            refresh
        }
    }
};